<template>
  <div id="simulation-page-layout">
    <div class="simulation-header">
      <slot name="header"></slot>
    </div>
    <div class="simulation-content">
      <slot></slot>
    </div>
    <div class="simulation-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss">

#simulation-page-layout {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: white;
  padding: 0;

  .simulation-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }

  .simulation-content {
    position: fixed;
    top: 6.375rem;
    left: 0;
    width: 100%;
    height: calc(100% - 8.125rem);
    overflow: auto;
    line-height: 1.5rem;
  }

  .simulation-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
